<template>
  <div>
    <b-modal
      id="delete-building-modal"
      v-if="data.allowed"
    >
      Czy jesteś pewnien, że chcesz usunąć budynek {{ data.info }}?

      <template #modal-footer="{ ok, cancel }">
        <b-button class="btn btn-primary" @click="deleteBuilding()">
          Tak, usuń
        </b-button>
        <b-button @click="cancel()">
          Cofnij
        </b-button>
      </template>
    </b-modal>
    <b-modal
      variant="danger"
      id="delete-building-modal"
      v-else
    >
      Nie można usunąć budynku dla którego są dodane deklaracje.

      <template #modal-footer="{ cancel }">
        <b-button class="btn btn-primary" @click="cancel()">
          Ok
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import LocationsModel from "@/models/locations";

export default {
  name: "DeleteBuildingModal",
  methods: {
    deleteBuilding() {
      if (!this.data.id) {
        return;
      }
      return LocationsModel.deleteBuilding(this.data.id)
        .then(() => {
          this.$emit('building-deleted');
           this.$bvModal.hide('delete-building-modal');
        });
    }
  },
  computed: {
    data() {
      return this.$store.state.deleteBuilding;
    }
  }

}
</script>

<style scoped>

</style>
